import { watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useMetaConversionAPI } from './useMetaConversionAPI';

export function usePageViewTracking() {
    const { metaPageView } = useMetaConversionAPI();
    const page = usePage();

    watch(() => page.url, (newUrl, oldUrl) => {
        if (newUrl !== oldUrl) {
            metaPageView();
        }
    }, { immediate: true });

    return {
        trackPageView: metaPageView
    };
} 